import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import cncf from "../../../../src/collections/blog/2020/2020-06-01-meshery-accepted-into-cncf-landscape/cncf-landscape-stacked-color.svg";
import cncfmeshery from "../../../../src/collections/blog/2020/2020-06-01-meshery-accepted-into-cncf-landscape/cncf-meshery-landscape.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  cncf,
  cncfmeshery,
  React
};